module.exports = __webpack_public_path__ + "static/media/Maf_Dane.75e6ade6.jpg";